var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "ns-popup" }, [
        _c("div", {
          staticClass: "pu-shield",
          on: {
            click: function($event) {
              return _vm.puClose("background")
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "pu-view" }, [
          _c(
            "header",
            { staticClass: "pu-head" },
            [
              _vm._t("default", [
                _c(
                  "div",
                  {
                    staticClass: "pu-head-slot",
                    style: {
                      "--ns-popup-puHeadSlotBackgroundUrl":
                        "url(" + _vm.puHeadSlotBackgroundUrl + ")"
                    }
                  },
                  [
                    _vm.headLogo
                      ? _c("div", { staticClass: "pu-head-slot-logo" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.headLogo,
                              alt: _vm.headLogoAltText
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.greeting
                      ? _c("div", { staticClass: "pu-head-slot-text" }, [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.greeting) }
                          })
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.closable
                ? _c(
                    "span",
                    {
                      staticClass: "pu-close-button",
                      on: {
                        click: function($event) {
                          return _vm.puClose("closeButton")
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            viewBox: "0 0 12 12",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink"
                          }
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                fill: "none",
                                stroke: "#FFFFFF",
                                "stroke-width": "1"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  d: "M 0 0 L 12 12 M 0 12 L 12 0"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pu-body" },
            [
              _vm.feedbackText
                ? _c(
                    "div",
                    [
                      _c("NsAlert", {
                        staticClass: "pu-alert",
                        attrs: {
                          type: "banner",
                          context: "error",
                          visible: true
                        },
                        on: {
                          dismiss: function($event) {
                            return _vm.hideFeedback()
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function() {
                                return [_vm._v(_vm._s(_vm.feedbackText))]
                              },
                              proxy: true
                            },
                            {
                              key: "foot",
                              fn: function() {
                                return [_vm._v(_vm._s(_vm.feedbackFoot))]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          663331300
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.contentSlots, function(slot) {
                return _c(
                  "div",
                  { key: slot.name, staticClass: "pu-slot" },
                  [_vm.view == slot.index ? _vm._t(slot.name) : _vm._e()],
                  2
                )
              })
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }